const actions = {
  SET_ALL_AGENTS: "SET_ALL_AGENTS",
  SET_ALL_LICENSES: "SET_ALL_LICENSES",
  SET_AGENT_RATES: "SET_AGENT_RATES",
  setAgents: (data) => ({
    type: actions.SET_ALL_AGENTS,
    payload: data,
  }),
  setLicenses: (data) => ({
    type: actions.SET_ALL_LICENSES,
    payload: data,
  }),
  setAgentRates: (data) => ({
    type: actions.SET_AGENT_RATES,
    payload: data,
  }),
};
export default actions;
